import React from 'react';
import ClipLoader from 'react-spinners/ClipLoader';

interface MiniSpinnerProps {
  centerAligned?: boolean;
}

function MiniSpinner({ centerAligned }: MiniSpinnerProps) {
  return (
    <div
      className={
        centerAligned
          ? 'mini-spinner d-flex justify-content-center align-items-center h-100'
          : 'mini-spinner'
      }
      data-testid='component-MiniSpinner'
    >
      <ClipLoader color='#1B8EB7' loading={true} />
    </div>
  );
}

export default React.memo(MiniSpinner);
